import React from "react";
import TrainingAndCertificationView from "./view";

const TrainingAndCertificationPage = () => {
  return <TrainingAndCertificationView />;
};

export default TrainingAndCertificationPage;